import { inject, Injectable, signal } from '@angular/core';
import { ClubApp } from '@aaa/emember/types';
import { CookiesService } from '../../../share/services/cookies.service';
import { isFlagEnabled } from '../../../../store/feature-flags';
import { FeatureName } from '../../../../store/feature-flags/types';
import { environment } from '../../../../../environments/environment';

const COOKIE_NAME = 'ava-tester-gate';
const COOKIE_DAYS = 1;

// Not a secret: the gate only keeps the public out while the club's new system is on the internet. The code
// ships in the bundle and the cookie can be set by hand
const TESTER_CODES: Partial<Record<ClubApp, string>> = {
  [ClubApp.Northampton]: '188QVJQVHX',
  [ClubApp.Shelby]: '160QJJSZYD',
};

@Injectable({ providedIn: 'root' })
export class TesterGateService {
  private cookies = inject(CookiesService);

  readonly open = signal(
    !isFlagEnabled(FeatureName.TESTER_GATE) || this.cookies.getCookie(COOKIE_NAME) === environment.clubId,
  );

  enter(code: string) {
    const expected = TESTER_CODES[environment.clubId];

    if (!expected || code.trim().toUpperCase() !== expected.toUpperCase()) {
      return false;
    }

    this.cookies.setCookie(COOKIE_NAME, environment.clubId, COOKIE_DAYS, '/');
    this.open.set(true);

    return true;
  }
}
